var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 2H4.99992C4.55789 2 4.13397 2.17559 3.82141 2.48816C3.50885 2.80072 3.33325 3.22464 3.33325 3.66667V17C3.33325 17.442 3.50885 17.8659 3.82141 18.1785C4.13397 18.4911 4.55789 18.6667 4.99992 18.6667H14.9999C15.4419 18.6667 15.8659 18.4911 16.1784 18.1785C16.491 17.8659 16.6666 17.442 16.6666 17V6.58333L12.0833 2Z",
    stroke: "#8B38FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 2V7H16.6667",
    stroke: "#8B38FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 11.166H6.66675",
    stroke: "#8B38FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 14.5H6.66675",
    stroke: "#8B38FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33341 7.83301H6.66675",
    stroke: "#8B38FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIconPurple);
export default __webpack_public_path__ + "static/media/doc-icon-purple.d1da1ad3c19afa8c0bcf50c6e5416f73.svg";
export { ForwardRef as ReactComponent };